module.exports = __webpack_public_path__ + "img/bf.fbd0eea0.svg";